






































































































































import { Component, Vue } from 'vue-property-decorator';
import VxBreadcrumb from '@/layouts/components/VxBreadcrumb.vue';
import BookingComponent from '@/components/common/BookingComponent.vue';
import router from '@/router';
import AuthModule from '@/store/AuthModule';

@Component({
    components: {
    },
})
export default class AfterLoginSelector extends Vue {
    showTrialPopup = false;
    remainingDays = 0;

    get businessDevelopper() {
        return AuthModule.business_developper;
    }

    async mounted() {
        // Wait for page to fully render before showing popup
        await this.$nextTick();
        
        // Add delay to ensure everything is loaded - reduced to 500ms
        setTimeout(() => {
            this.checkTrialStatus();
        }, 500);
    }

    checkTrialStatus() {
        const isTrialActive = AuthModule.isTrialActive;
        const isSubscriptionActive = AuthModule.isSubscriptionActive;
        
        console.log('Trial status check:', { isTrialActive, isSubscriptionActive });
        
        if (isTrialActive === true && isSubscriptionActive === false) {
            this.calculateRemainingDays();
            this.showTrialPopup = true;
        }
    }

    calculateRemainingDays() {
        const subscriptions = AuthModule.subscriptions;
        
        if (subscriptions && subscriptions.length > 0) {
            const latestSubscription = subscriptions[subscriptions.length - 1];
            
            if (latestSubscription.start_at) {
                // Trial period is 14 days from start_at
                const startDate = new Date(latestSubscription.start_at);
                const trialEndDate = new Date(startDate);
                trialEndDate.setDate(trialEndDate.getDate() + 14); // Add 14 days
                
                const today = new Date();
                const diffTime = trialEndDate.getTime() - today.getTime();
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                
                this.remainingDays = diffDays > 0 ? diffDays : 0;
                
                console.log('Trial calculation:', {
                    startDate: startDate.toISOString(),
                    trialEndDate: trialEndDate.toISOString(),
                    today: today.toISOString(),
                    remainingDays: this.remainingDays
                });
            } else {
                // Fallback if no start_at
                this.remainingDays = 14;
            }
        } else {
            // Default to 14 days if no subscription data
            this.remainingDays = 14;
        }
    }

    closePopup() {
        this.showTrialPopup = false;
    }

    getService(): string | null {
        return localStorage.getItem('service');
    }

    setStateService(service: string) {
    localStorage.setItem('service', service);
    
    // Redirection différente selon le service sélectionné
    if (service === 'immo') {
        return this.$router.push({ name: 'homePrescriber' });
    } else if (service === 'credit') {
        return this.$router.push({ name: 'CreditRequest' });
    } else if (service === 'lead') {
        return this.$router.push({ name: 'DataRequest' });
    } else {
        // Cas par défaut si besoin
        return this.$router.push({ name: 'createProspect' });
    }
    }
}
